import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import FUNNEL_CONSTANTS from "../constants";

export function FirstContactTypeFilter() {
  const dispatch = useDispatch();

  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);
  const selected = useSelector((state) => state.laser.selectedFilters.firstContactType);

  return startFrom === "leads" ? (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">First Contact Type</p>
      <MultiSelectDropdown
        options={FUNNEL_CONSTANTS.FIRST_CONTACT_TYPE_OPTIONS}
        selectedFilters={selected}
        numberDisplayed={0}
        includeFilter={false}
        onSelectChange={(data) => dispatch(actionCreators.setFirstContactType(data))}
      />
    </div>
  ) : null;
}
